import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { ConfigService } from '@acpgruppe/essp-ui';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent {


  constructor(private oauthService: OAuthService,configService: ConfigService) {
    configService.setStage(environment.stage);
    configService.setAppPrefix(environment.appPrefix);
    if (!this.oauthService.hasValidAccessToken()) {
      throw new Error('No valid access token!');
    } else {
      console.log('Root component loaded');
    }
  }
}
